<template>
  <div class="car-manage">
    <el-form :model="searchData" ref="search">
      <QS-search maxLine="2" ref="BLM-search">
        <el-form-item prop="createTime" label="创建时间">
          <el-date-picker
            v-model="searchData.createTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="completeTime" label="完成时间">
          <el-date-picker
            v-model="searchData.completeTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="discardTime" label="作废时间">
          <el-date-picker
            v-model="searchData.discardTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="批量付款状态" prop="state">
          <el-select
            v-model="searchData.state"
            clearable
            placeholder="请选择批量付款状态"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in batchStateList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="id" label="批量付款ID">
          <el-input
            v-number:integer
            v-model="searchData.id"
            placeholder="请输入批量付款ID"
          ></el-input>
        </el-form-item>
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              type="primary"
              @click="searchHandle"
            >查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="reset('search')">重置</el-button>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <!-- 开始 ---列表 -->
    <QS-common-table
      ref="table"
      :loading="oLoading.search"
      :data="carDataList"
      :columns="headData"
      :pagination="paginationData"
      @change="paginationChange"
    />
    <!-- 作废 -->
    <dialogWrap
      v-model="oShow.Invalid"
      title="提示"
      width="'560px'"
      custom-class="dialog-message"
    >
      <div class="mb-20">关闭后将同步作废相关付款单，应付单需要重新收款。</div>
      <div v-if="DingTalkShow24">
        <el-form
          ref="deleteReasonform"
          :model="deleteReasonform"
          label-width="120px"
          size="small"
          :rules="deleteReasonrules"
        >
          <el-form-item label="作废备注原因：" prop="discardReason">
            <el-input
              type="textarea"
              maxlength="1000"
              v-model="deleteReasonform.discardReason"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template slot="footer">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button
          :loading="oLoading.state"
          size="small"
          type="primary"
          v-submitDingTalkShow="24"
          @click="submitInvalidHandle"
        >确认</el-button>
      </template>
    </dialogWrap>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import {
  getbatchPaymentRecordList,
  batchPaymentRecordDiscard,
} from '@/api/financeApi'
import selectOption from '@/store/dict/selectOptionDict'
import { submitDingTalkShow } from '@/directives/submitDingTalkShow'
import * as Sentry from '@sentry/vue'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  data() {
    return {
      deleteReasonform: { discardReason: '' }, // 作废备注原因
      deleteReasonrules: {
        discardReason: [
          { required: true, message: '请填写作废备注原因', trigger: 'blur' },
        ],
      },
      oShow: {
        Invalid: false,
      },
      Invalid: '',
      oLoading: {
        search: false,
        state: false,
      },
      activeName: 'allCars',
      activeValue: 1,
      selectedData: [], // 选中的数据
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      customerList: [],
      DingTalkShow24: false,
      switchNav: [
        {
          name: '全部车辆',
          key: 'allCars',
          number: 0,
          value: 1,
        },
        {
          name: '已签约车辆',
          key: 'signedCar',
          number: 0,
          value: 8,
        },
        {
          name: '未签约车辆',
          key: 'waitContract',
          number: 0,
          value: 2,
        },
        {
          name: '签署中车辆',
          key: 'signingCar',
          number: 0,
          value: 9,
        },
        {
          name: '在库车辆',
          key: 'inGarage',
          number: 0,
          value: 3,
        },
        {
          name: '出库车辆',
          key: 'outGarage',
          number: 0,
          value: 10,
        },
        {
          name: '维修中车辆',
          key: 'repair',
          number: 0,
          value: 4,
        },
        {
          name: '保养中车辆',
          key: 'maintain',
          number: 0,
          value: 5,
        },
        {
          name: '事故中车辆',
          key: 'accident',
          number: 0,
          value: 6,
        },
        {
          name: '退出运营车辆',
          key: 'exitOperation',
          number: 0,
          value: 7,
        },
      ],
      searchData: {
        type: 2,
        createTime: [], // 创建时间
        completeTime: [], // completeTime
        discardTime: [], // 作废时间
        state: '', // 批量付款状态
        customerType: '', // 付款方类型
        customerId: '', // 收款方
        receivableAccount: '', // 收款账户
        paymentAccountId: '', // 付款账户
        id: '', // 批量付款ID
      },
      headData: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '批量付款ID',
            fixed: 'left',
            width: 120,
          },
          render: ({ row }) => (
            <a
              href="javascript:void(0);"
              onClick={() => this.viewDetails(row.id)}
            >
              {row.id}
            </a>
          ),
        },
        {
          name: 'amount',
          columnProps: {
            prop: 'amount',
            label: '付款金额（元）',
            width: 120,
          },
          getText: ({ row }) => this.numberWithCommas(row.amount),
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '批量付款状态',
            width: 120,
          },
          getText: ({ row }) => selectOption.batchStateDict[row.state],
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '创建时间',
          },
          render: ({ row }) => {
            return (
              <div>
                <span>{row.gmtCreate && row.gmtCreate.split(' ')[0]}</span>
                <br />
                <span>{row.gmtCreate && row.gmtCreate.split(' ')[1]}</span>
              </div>
            )
          },
        },
        {
          name: 'completeTime',
          columnProps: {
            prop: 'completeTime',
            label: '完成时间',
          },
          render: ({ row }) => {
            return (
              <div>
                <span>
                  {row.completeTime && row.completeTime.split(' ')[0]}
                </span>
                <br />
                <span>
                  {row.completeTime && row.completeTime.split(' ')[1]}
                </span>
              </div>
            )
          },
        },
        {
          name: 'discardTime',
          columnProps: {
            prop: 'discardTime',
            label: '作废时间',
          },
        },
        {
          name: 'createUserName',
          columnProps: {
            prop: 'createUserName',
            label: '创建人',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const arr = [
              {
                name: 'del',
                label: '作废',
                action: () => this.handelInvalid(row.id),
              },
            ]
            if (
              Number(row.state) === 1 &&
              this.judgePermission('finance_batch_receivable_record_detail')
            ) {
              return arr
            }
          },
        },
      ],
      carDataList: [],
    }
  },
  mounted() {
    this.$refs['BLM-search'].searchMoreClick()
    if (this.$route.query.type) {
      try {
        this.activeValue = parseInt(this.$route.query.type, 10)
        this.activeName = this.switchNav.filter(
          (item) => item.value === this.activeValue,
        )[0].key
      } catch (error) {
        Sentry.captureException(error)
      }
    }

    if (!this.activeValue) {
      this.activeValue = 1
    }

    this.getBatchPaymentRecordListFun()
    this.URL = this.uploadServiceUrl
  },
  watch: {
    selectedData: {
      handler(val) {
        if (val.length) {
          this.getDisabled(this.carDataList[val[0]])
        } else {
          this.resetDisabled()
        }
      },
      deep: true,
    },
  },
  computed: {
    batchStateList() {
      return this.dictParseList(selectOption.batchStateDict)
    },
  },
  methods: {
    resetDeleteReasonForm() {
      if (this.DingTalkShow24) {
        this.deleteReasonform.discardReason = ''
        this.$refs?.deleteReasonform?.resetFields()
      }
    },
    // 取消弹窗
    handleCancel() {
      this.oShow.Invalid = false
      this.resetDeleteReasonForm()
    },
    // 作废确认
    async submitInvalidHandle() {
      if (this.oLoading.state) return
      this.oLoading.state = true
      try {
        if (this.DingTalkShow24) {
          const valid = await this.$refs?.deleteReasonform?.validate()
          if (!valid) {
            this.$message.warning('请填写作废原因！')
            return
          }
        }
        const { code } = await batchPaymentRecordDiscard({
          id: this.Invalid,
          discardReason: this.deleteReasonform.discardReason,
        })
        if (code !== 1) return
        this.oShow.Invalid = false
        this.resetDeleteReasonForm()
        this.searchHandle()
      } finally {
        this.oLoading.state = false
      }
    },
    // 作废弹窗
    handelInvalid(id) {
      this.oShow.Invalid = true
      this.Invalid = id
    },

    // 搜索事件
    searchHandle() {
      const par = {
        pageSize: this.paginationData.pageSize,
        pageNum: 1,
      }
      this.paginationChange({ pagination: { ...par } })
    },

    // 获取列表数据
    getBatchPaymentRecordListFun() {
      this.oLoading.search = true
      let createStartDate = null // 创建开始日期
      let createEndDate = null // 创建结束日期
      if (
        this.searchData.createTime instanceof Array &&
        this.searchData.createTime.length
      ) {
        createStartDate = this.searchData.createTime[0] || null
        createEndDate = this.searchData.createTime[1] || null
      }
      let completeStartDate = null // 完成开始日期
      let completeEndDate = null // 完成结束日期
      if (
        this.searchData.completeTime instanceof Array &&
        this.searchData.completeTime.length
      ) {
        completeStartDate = this.searchData.completeTime[0] || null
        completeEndDate = this.searchData.completeTime[1] || null
      }
      let discardStartDate = null // 作废开始日期
      let discardEndDate = null // 作废结束日期
      if (
        this.searchData.discardTime instanceof Array &&
        this.searchData.discardTime.length
      ) {
        discardStartDate = this.searchData.discardTime[0] || null
        discardEndDate = this.searchData.discardTime[1] || null
      }
      getbatchPaymentRecordList({
        ...this.searchData,
        createStartDate,
        createEndDate,
        completeStartDate,
        completeEndDate,
        discardStartDate,
        discardEndDate,
        pageSize: this.paginationData.pageSize,
        pageNum: this.paginationData.pageNum,
      }).then((res) => {
        const { code, data } = res
        if (code !== 1) {
          return
        }
        if (data.items && data.items.length) {
          data.items.forEach((item) => {
            this.$set(item, 'checked', false)
          })
          if (this.selectedData.length) {
            this.selectedData.pop()
          }
          data.items.forEach((item) => {
            if (this.activeValue === 7) {
              item.exitOperationState = 1
            } else {
              item.exitOperationState = 0
            }
          })
          this.carDataList = data.items
          this.paginationData.total = data.totalNum
        } else {
          this.carDataList = []
          this.paginationData.total = 0
        }
      }).finally(() => {
        this.oLoading.search = false
      })
    },
    // 分页效果
    paginationChange(result) {
      const { pagination } = result
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getBatchPaymentRecordListFun()
    },
    // 清空然后搜索
    reset(form) {
      this.$refs[form].resetFields()
      this.customerList = []
      this.searchHandle()
    },
    // 查看详情
    viewDetails(id) {
      if (!this.judgePermission('finance_batch_payment_record_detail')) return
      this.$router.push({
        name: 'finance_batch_payment_record_detail',
        query: { id },
      })
    },
  },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.operation-box {
  margin: 16px 0;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
}

.customerInfo {
  ::v-deep .el-input--small {
    width: 200px;
  }
}
.customer {
  display: flex;
  flex-direction: row;
  &-name {
    // float: left;
    width: 80px;
    height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
  }
  &-phone {
    // float: left;
    color: #8492a6;
    font-size: 13px;
    margin: 0;
    padding-left: 20px;
  }
}
</style>
